import { ToastProvider } from "./ToastContext";
import { Toaster } from "./Toaster";

// @ts-ignore (fix me please, do not replicate)
export function ToastFrame({ children }) {
  return (
    <ToastProvider>
      <Toaster />
      {children}
    </ToastProvider>
  );
}
